
import { mapGetters } from "vuex";
export default {
	components: {
		vcDynamicLink	: () => import('../../components/pages/dynamic-link.vue')
	},
	computed: {
		...mapGetters({
			getterTranslates: 'getterTranslates',
			getterStoreLang : 'getterStoreLang'
		})
	}
}
